export default "__VITE_ASSET__CDlIz8da__"